<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-table
        title="Histórico de retorno"
        :data="History.data"
        :columns="columns"
        row-key="id"
        :loading="$apollo.loading"
        :pagination.sync="pagination"
        @request="onRequest"
      >
        <template v-slot:top="props">
          <div class="row col-12 q-col-gutter-xs">
            <div class="col-12 text-center text-h3">Histórico Geral</div>
          </div>
          <div class="row col-12">
              <q-input outlined style="border: 1px solid white;" dense input-class="inputSearch" debounce="300"
                        v-model="filter"
                       placeholder="Buscar">
                <template v-slot:append>
                  <q-icon name="search"/>
                </template>
              </q-input>
          </div>
        </template>
      </q-table>
    </div>

  </q-page>
</template>

<script>
import { GENERAL_HISTORY, GENERAL_History } from '../graphql/graphql'
import { DateTime } from 'luxon'

export default {
  name: 'Doadores',
  data () {
    return {
      filter: '',
      History: {
        data: [],
        paginatorInfo: {
          total: 0
        }
      },
      columns: [
        {
          name: 'created_at',

          label: 'Data da ocorrência',
          align: 'left',
          field: 'created_at',
          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString(DateTime.DATETIME_SHORT)
          }
        }, {
          name: 'type',

          label: 'Agente',
          align: 'left',
          field: 'type'
        }, {
          name: 'title',

          label: 'Título da ocorrência',
          align: 'left',
          field: 'title'
        }, {
          name: 'description',

          label: 'Descrição da ocorrência',
          align: 'left',
          field: 'description'
        }, {
          name: 'user',

          label: 'Autor',
          align: 'left',
          field: 'user',
          format: val => {
            if (val) {
              return val.name
            }
          }
        }
      ],
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 3,
        rowsNumber: 3
      }
    }
  },
  apollo: {
    History: {
      query: GENERAL_HISTORY,
      variables () {
        return {
          page: this.pagination.page,
          count: this.pagination.rowsPerPage,
          orderBy: [{ field: 'id', order: 'DESC' }]
        }
      },
      skip: true
      // pollInterval: 300, // ms
    }
  },
  methods: {
    onRequest (props) {
      this.pagination.page = props.pagination.page
      this.pagination.rowsPerPage = props.pagination.rowsPerPage

      this.$apollo.addSmartQuery('History', {
        query: GENERAL_HISTORY,
        variables () {
          return {
            'page': props.pagination.page || 1,
            'count': props.pagination.rowsPerPage || 3,
            orderBy: [{ field: 'id', order: 'DESC' }]
          }
        }
      })
    }
  },
  mounted () {
    this.$apollo.queries.History.skip = false
    this.$apollo.queries.History.refetch().then(result => this.pagination.rowsNumber = result.data.History.paginatorInfo.total)
  }
}
</script>
<style>
  .q-table__top,
  .q-table__bottom,
  .q-field__native,
  .q-icon,
  thead tr:first-child th {

    background-color: #590a7f;
    color: #ffffff !important;
  }

  .q-table__middle {
    max-height: 600px;
  }

  thead tr:first-child th {
    position: sticky;
    top: 0;
    opacity: 1;
    z-index: 1;
  }

  .row {
    margin: 0;
  }

  input[type='text'].inputSearch {
    color: white !important;
  }

  .q-table__top {
    border-bottom: 3px solid white;
  }
</style>
